import { Box, Tooltip } from "@mui/material";
import type React from "react";

export interface ReportCardMetaItem {
  key: string;
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
}

interface ReportOrderCardHeaderProps {
  idSlot: React.ReactNode;
  secondarySlot?: React.ReactNode;
  statusSlot: React.ReactNode;
  actionsSlot?: React.ReactNode;
  meta: ReportCardMetaItem[];
  testId?: string;
}

const metaItemSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.5,
  minWidth: 0,
  color: "text.primary",
} as const;

const ReportOrderCardHeader: React.FC<ReportOrderCardHeaderProps> = ({
  idSlot,
  secondarySlot,
  statusSlot,
  actionsSlot,
  meta,
  testId,
}) => (
  <Box data-testid={testId} sx={{ mb: 1.25 }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        columnGap: 1,
        rowGap: 0.75,
        flexWrap: "wrap",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          minWidth: 0,
          flexWrap: "wrap",
          flex: 1,
        }}
      >
        {idSlot}
        {statusSlot}
        {secondarySlot ? (
          <>
            <Box component="span" sx={{ color: "text.disabled" }}>
              ·
            </Box>
            {secondarySlot}
          </>
        ) : null}
        {meta.length > 0 ? (
          <>
            <Box component="span" sx={{ color: "text.disabled" }}>
              ·
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                columnGap: 2,
                rowGap: 0.5,
                minWidth: 0,
              }}
            >
              {meta.map((item) => (
                <Tooltip key={item.key} title={item.label}>
                  <Box aria-label={item.label} sx={metaItemSx}>
                    {item.icon}
                    {item.value}
                  </Box>
                </Tooltip>
              ))}
            </Box>
          </>
        ) : null}
      </Box>
      {actionsSlot ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            flexWrap: "wrap",
            ml: "auto",
            justifyContent: "flex-end",
          }}
        >
          {actionsSlot}
        </Box>
      ) : null}
    </Box>
  </Box>
);

export default ReportOrderCardHeader;
